import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import * as BsIcons from "react-icons/bs";
import * as GiIcons from "react-icons/gi";
import { HiOfficeBuilding } from "react-icons/hi";
import { translate, verifyHideCountry, verifyHideCountry2, findActionsByPath } from "../utils/Common";
import { LuAlertCircle } from "react-icons/lu";
import {
  parseBliPermissionsFromSession,
  resolveModuleIdForPath,
  getActionCodesForModuleFromAssignments,
  normalizePathForBli,
} from "./bliPermissionsRuntime";

/** Rutas estáticas por rol: probar pathname y variantes normalizadas (slash, query). */
function actionsForPathFromStaticRole(roleConfig, rawPath) {
  if (!roleConfig?.options || !rawPath) return [];
  const noQuery = String(rawPath).split("?")[0].trim();
  if (!noQuery) return [];
  const norm = normalizePathForBli(noQuery);
  const withSlash = noQuery.endsWith("/") ? noQuery : `${noQuery}/`;
  const candidates = [noQuery, norm, withSlash, normalizePathForBli(withSlash)];
  const seen = new Set();
  for (const p of candidates) {
    if (!p || seen.has(p)) continue;
    seen.add(p);
    const actions = findActionsByPath(roleConfig, p);
    if (actions.length > 0) return actions;
  }
  return [];
}

const optionsPages = {
  verifyCountry: verifyHideCountry(),
  iconsClosed: {
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  actions: {
    read: {
        1: "view_availability_doors",
        2: "view_movements_doors",
        3: "view_screen_platforms",
        4: "view_screen_billing_admin",
        5: "view_screen_support_platforms",
        6 : "view_package_options_details",
        7: "view_qrcode_package",
        8: "view_locate_platform",
        9: "view_screen_arching",
        10: "view_screen_clients",
        11: "view_screen_alerted_packages",
        12: "view_screen_generate_qr",
        13: "view_screen_create_platform",
        14: "view_search_client_statistic",
        15: "view_screen_companies"
    },
    create: {
      1: "create_package",
      2: "create_locker",
      3: "create_company"
    },
    update: {
      1: "update_package",
      2: "open_door_remote",
      3: "update_locker",
      4: "lock_doors",
      5: "unlock_doors",
      6: "update_package_expiration",
      7: "reset_locker",
      8: "update_change_platform",
      9: "update_change_info_package",
      10: "update_reservation_package",
      11: "update_force_delivery_package",
      12: "update_change_client",
      13: "update_management_balance",
      14: "update_company_logo",
      15: "update_company_info",
    },
    delete: {
      1: "delete_package",
      2: "cancel_package",
      3: "delete_locker",
      4: "remove_package",
    },
    search : {
        1: "search_package",
        2: "search_locker"
    }
  },
};

const pagesConfig = {
  1: {
    title: translate("sidebar.options.start"),
    path: "/dashboard/",
    icon: <FaIcons.FaHome />,
  },
  2: {
    title: translate("sidebar.options.packages.load"),
    path: "/dashboard/packages/load",
    icon: <FaIcons.FaCube />,
  },
  3: {
    title: translate("sidebar.options.packages.loadpackage"),
    path: "/dashboard/packages/loadpackage",
    icon: <FaIcons.FaCube />,
    actions : []
  },
  4: {
    title: translate("sidebar.options.packages.reservations"),
    path: "/dashboard/lockers/reservations",
    icon: <BsIcons.BsInboxesFill />,
  },
  5: {
    title: translate("sidebar.options.packages.deliveries"),
    path: "/dashboard/lockers/awaitingDelivery",
    icon: <FaIcons.FaCar />,
  },
  6: {
    title: translate("sidebar.options.packages.tracking"),
    path: "/dashboard/packages/tracking",
    icon: <FaIcons.FaSearch />,
    actions: [],
  },
  7: {
    title: translate("sidebar.options.platforms.general"),
    path: "/dashboard/platforms/general",
    icon: <FaIcons.FaFileAlt />,
    actions:[]
  },
  8: {
    title: translate("sidebar.options.platforms.support"),
    path: "/dashboard/platforms/support",
    icon: <FaIcons.FaTools />,
    actions: []
  },
  9: {
    title: translate("global.registerIncident"),
    path: "/dashboard/incidents/register",
  },
  10: {
    title: translate("global.listIncident"),
    path: "/dashboard/incidents",
  },
  11: {
    title: translate("sidebar.options.counter.dropoff"),
    path: "/dashboard/packages/dropoff",
    icon: <BsIcons.BsBoxArrowInDown />,
  },
  12: {
    title: translate("sidebar.options.counter.pickup"),
    path: "/dashboard/packages/pickup",
    icon: <BsIcons.BsBoxArrowUp />,
  },
  13: {
    title: translate("sidebar.options.faqs"),
    path: "/dashboard/faqs",
    icon: <FaIcons.FaQuestion />,
  },
  14: {
    title: translate("global.InvoicingAndUsage"),
    path: "/dashboard/billing",
    icon: <BsIcons.BsCreditCard />,
  },
  15: {
    title: translate("sidebar.options.statistics"),
    path: "/dashboard/insights",
    icon: <FaIcons.FaChartPie />,
  },
  16: {
    title: translate("sidebar.options.accounting.searchTransactions"),
    path: "/dashboard/accounting",
    icon: <BsIcons.BsCashCoin />,
  },
  17: {
    title: translate("sidebar.options.accounting.billing"),
    path: "/dashboard/adminBilling",
    icon: <BsIcons.BsCashCoin />,
  },
  18: {
    title: translate("global.clients"),
    path: "/dashboard/clients",
    icon: <BsIcons.BsPeople />,
  },
  19: {
    title: translate("global.locate"),
    path: "/dashboard/platforms/locate",
    icon: <BsIcons.BsGeoAlt />,
  },
  20: {
    title: translate("sidebar.options.accounting.arching"),
    path: "/dashboard/accounting/arching",
    actions:[]
  },
  21: {
    title: translate("sidebar.options.packages.alerted"),
    path: "/dashboard/packages/alerted",
    icon: <FaIcons.FaBell />,
    actions: [],
  },
  22: {
    title: translate("sidebar.options.platforms.GenerateQR"),
    path: "/dashboard/platforms/GenerateQR",
    icon: <FaIcons.FaQrcode />,
    actions: [],
  },
  23: {
    title: translate("sidebar.options.platforms.createPlatform"),
    path: "/dashboard/platforms/settings?view=create",
    icon: <GiIcons.GiPlatform />,
    actions: [],
  },
  24: {
    title: translate("sidebar.options.statistics"),
    path: "/dashboard/insights",
    icon: <FaIcons.FaChartPie />
  },
  25: {
    title: translate("sidebar.options.companies"),
    path: "/dashboard/companies",
    icon: <HiOfficeBuilding />,
    actions: []
  }
};

const modulesPages = {
  1: {
    title: translate("sidebar.options.packages"),
    path: "/dashboard/packages/",
    icon: <FaIcons.FaCube />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  2: {
    title: translate("sidebar.options.platforms"),
    path: "/dashboard/platforms/",
    icon: <GiIcons.GiPlatform />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  3: {
    title: translate("sidebar.options.incidents"),
    path: "/dashboard/incidents",
    icon: <LuAlertCircle />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  4: {
    title: translate("sidebar.options.counter"),
    path: "/dashboard/packages/",
    icon: <FaIcons.FaTabletAlt />,
    ...optionsPages.iconsClosed,
    isVisible: optionsPages.verifyCountry,
    subNav: [],
  },
  5: {
    title: translate("sidebar.options.accounting"),
    path: "/",
    icon: <BsIcons.BsCashCoin />,
    ...optionsPages.iconsClosed,
    isVisible: optionsPages.verifyCountry,
    subNav: [],
  },
};

export const configRolesUsers = {
  1: {
    idRole: 1,
    name: translate("global.typesRoleBli.1"),
    idTypeUser: 3,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
          pagesConfig[2],
          {
            ...pagesConfig[3],
            actions: [
              optionsPages.actions.create[1],
              optionsPages.actions.search[2],
              optionsPages.actions.delete[2],
              optionsPages.actions.update[2]
            ]
          },
          {
            ...pagesConfig[6],
            actions: [
              optionsPages.actions.search[1],
              optionsPages.actions.read[6],
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7]
            ]
          }
        ]
      },
      pagesConfig[4],
      pagesConfig[5],
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[19],
            actions: [optionsPages.actions.read[8]]
          }
        ]
      },
      pagesConfig[14],
      {...pagesConfig[24], actions: []},
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      }
    ]
  },

  2: {
    idRole: 2,
    name: translate("global.typesRoleBli.2"),
    idTypeUser: 3,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
          pagesConfig[2],
          {
            ...pagesConfig[3],
            actions: [
              optionsPages.actions.create[1],
              optionsPages.actions.search[2],
              optionsPages.actions.delete[2],
              optionsPages.actions.update[2]
            ]
          },
          {
            ...pagesConfig[6],
            actions: [
              optionsPages.actions.search[1],
              optionsPages.actions.read[6],
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7]
            ]
          }
        ]
      },
      pagesConfig[4],
      pagesConfig[5],
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[19],
            actions: [optionsPages.actions.read[8]]
          }
        ]
      },
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      }
    ]
  },

  3: {
    idRole: 3,
    name: translate("global.typesRoleBli.3"),
    idTypeUser: 3,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
          {
            ...pagesConfig[2]
          },
          {
            ...pagesConfig[3],
            actions: [
              optionsPages.actions.create[1],
              optionsPages.actions.search[2],
              optionsPages.actions.delete[2],
              optionsPages.actions.update[2]
            ]
          },
          {
            ...pagesConfig[6],
            actions: [
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.update[11],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7],
              optionsPages.actions.update[6]
            ]
          }
        ]
      },
      pagesConfig[4],
      pagesConfig[5],
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[7],
            actions: [
              optionsPages.actions.read[1],
              optionsPages.actions.update[2],
              optionsPages.actions.read[2],
              optionsPages.actions.read[3],
              optionsPages.actions.update[7],
              optionsPages.actions.read[6],
              optionsPages.actions.read[13]
            ]
          },
          {
            ...pagesConfig[8],
            actions: [optionsPages.actions.read[5]]
          },
          {
            ...pagesConfig[19],
            actions: [optionsPages.actions.read[8]]
          },
          ...(verifyHideCountry2() ? [{
              ...pagesConfig[22],
              actions: [optionsPages.actions.read[12]]
          }] : [])
        ]
      },
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      },
      {...pagesConfig[24], actions: []} 
    ]
  },

  4: {
    idRole: 4,
    name: translate("global.typesRoleBli.4"),
    idTypeUser: 3,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
            {
                ...pagesConfig[6],
                actions: [
                    optionsPages.actions.search[1],
                    // optionsPages.actions.read[6]
                ]
            }
        ]
    },
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[7],
            actions: [
              optionsPages.actions.read[1],
              optionsPages.actions.update[2],
              optionsPages.actions.read[2],
              optionsPages.actions.update[4],
              optionsPages.actions.update[5],
              optionsPages.actions.update[3],
              optionsPages.actions.read[3],
              optionsPages.actions.update[7],
              optionsPages.actions.read[13],
            ]
          },
          // Support (pagesConfig[8]) oculto para RoleBli 4
          ...(verifyHideCountry2() ? [{
              ...pagesConfig[22],
              actions: [optionsPages.actions.read[12]]
          }] : [])
        ]
      },
      {
        ...pagesConfig[18],
        actions: [
          optionsPages.actions.read[10]
        ]
      },
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      },
      {
        ...pagesConfig[25],
        actions: [optionsPages.actions.read[15]]
      }
    ]
  },

  5: {
    idRole: 5,
    name: translate("global.typesRoleBli.5"),
    idTypeUser: 3,
    isAdmin: true,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
          pagesConfig[2],
          {
            ...pagesConfig[3],
            actions: [
              optionsPages.actions.create[1],
              optionsPages.actions.search[2],
              optionsPages.actions.delete[2],
              optionsPages.actions.update[2]
            ]
          },
          pagesConfig[4],
          pagesConfig[5],
          {
            ...pagesConfig[6],
            actions: [
              optionsPages.actions.search[1],
              optionsPages.actions.read[6],
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.update[11],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7],
              optionsPages.actions.update[6]
            ]
          }
        ]
      },
      // Accounting oculto para todos los RoleBli
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      },
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[7],
            actions: [
              optionsPages.actions.read[1],
              optionsPages.actions.update[2],
              optionsPages.actions.read[2],
              optionsPages.actions.update[4],
              optionsPages.actions.update[5],
              optionsPages.actions.update[3],
              optionsPages.actions.read[3],
              optionsPages.actions.update[7]
            ]
          },
          {
            ...pagesConfig[19],
            actions: [optionsPages.actions.read[8]]
          },
          ...(verifyHideCountry2() ? [{
              ...pagesConfig[22],
              actions: [optionsPages.actions.read[12]]
          }] : [])
        ]
      },
      {
        ...pagesConfig[18],
        actions: [
          optionsPages.actions.update[13],
          optionsPages.actions.read[10]
        ]
      },
      {...pagesConfig[24], actions: [optionsPages.actions.read[14]]},
      {
        ...pagesConfig[25],
        actions: [
          optionsPages.actions.read[15],
          optionsPages.actions.create[3],
          optionsPages.actions.update[14],
          optionsPages.actions.update[15]
        ]
      }
    ]
  },

   6:     {
      idRole: 6,
      name: translate("global.typesRoleBli.6"),
      idTypeUser: 3,
      isAdmin: true,
      options: [
          pagesConfig[1],
          {
              ...modulesPages[1],
              subNav: [
                  pagesConfig[2],
                  {
                      ...pagesConfig[3],
                      actions: [
                          optionsPages.actions.create[1],
                          optionsPages.actions.search[2],
                          optionsPages.actions.delete[2],
                          optionsPages.actions.update[2]
                      ]
                  },
                  pagesConfig[4],
                  pagesConfig[5],
                  {
                      ...pagesConfig[6],
                      actions: [
                          optionsPages.actions.search[1],
                          optionsPages.actions.read[6],
                          optionsPages.actions.update[8],
                          optionsPages.actions.update[9],
                          optionsPages.actions.update[10],
                          optionsPages.actions.update[11],
                          optionsPages.actions.delete[4],
                          optionsPages.actions.read[7],
                          optionsPages.actions.update[6],
                          optionsPages.actions.update[12]
                      ]
                  }
              ]
          },
          // Counter oculto para todos los RoleBli
          {
              ...modulesPages[2],
              subNav: [
                  {
                      ...pagesConfig[7],
                      actions: [
                          optionsPages.actions.read[1],
                          optionsPages.actions.update[2],
                          optionsPages.actions.read[2],
                          optionsPages.actions.update[4],
                          optionsPages.actions.update[5],
                          optionsPages.actions.update[3],
                          optionsPages.actions.read[3],
                          optionsPages.actions.update[7],
                          optionsPages.actions.read[13]
                      ]
                  },
                  {
                      ...pagesConfig[8],
                      actions: [optionsPages.actions.read[5]]
                  },
                  {
                      ...pagesConfig[19],
                      actions: [optionsPages.actions.read[8]]
                  },
                  ...(verifyHideCountry2() ? [{
                      ...pagesConfig[22],
                      actions: [optionsPages.actions.read[12]]
                  }] : []),
              ]
          },
          {
              ...modulesPages[3],
              subNav: [pagesConfig[9], pagesConfig[10]]
          },
          // Accounting oculto para todos los RoleBli
          {
              ...pagesConfig[18],
              actions: [
                  optionsPages.actions.read[10],
                  optionsPages.actions.update[13]
              ]
          },
          {...pagesConfig[24], actions: [optionsPages.actions.read[14]]},
          {
            ...pagesConfig[25],
            actions: [
              optionsPages.actions.read[15],
              optionsPages.actions.create[3],
              optionsPages.actions.update[14],
              optionsPages.actions.update[15]
            ]
          }
      ]
  },

  7: {
    idRole: 7,
    name: translate("global.typesRoleBli.7"),
    idTypeUser: 3,
    isAdmin: true,
    options: [
      pagesConfig[1],
      {
        ...modulesPages[1],
        subNav: [
          pagesConfig[2],
          {
            ...pagesConfig[3],
            actions: [
              optionsPages.actions.create[1],
              optionsPages.actions.search[2],
              optionsPages.actions.delete[2]
            ]
          },
          pagesConfig[4],
          pagesConfig[5],
          {
            ...pagesConfig[6],
            actions: [
              optionsPages.actions.search[1],
              optionsPages.actions.read[6],
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.update[11],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7],
              optionsPages.actions.update[6],
              optionsPages.actions.update[12]
            ]
          }
        ]
      },
      // Counter oculto para todos los RoleBli
      {
        ...modulesPages[2],
        subNav: [
          {
            ...pagesConfig[7],
            actions: [
              optionsPages.actions.read[1],
              optionsPages.actions.update[2],
              optionsPages.actions.read[2],
              optionsPages.actions.read[3],
              optionsPages.actions.update[7],
              optionsPages.actions.read[6],
              optionsPages.actions.update[8],
              optionsPages.actions.update[9],
              optionsPages.actions.update[10],
              optionsPages.actions.delete[4],
              optionsPages.actions.read[7]
            ]
          },
          {
            ...pagesConfig[8],
            actions: [optionsPages.actions.read[5]]
          },
          ...(verifyHideCountry2() ? [{
              ...pagesConfig[22],
              actions: [optionsPages.actions.read[12]]
          }] : [])
        ]
      },
      // Accounting oculto para todos los RoleBli
      {
        ...modulesPages[3],
        subNav: [pagesConfig[9], pagesConfig[10]]
      },
      {
        ...pagesConfig[18],
        actions: [optionsPages.actions.read[10]]
      },
      {...pagesConfig[24], actions: [optionsPages.actions.read[14]]},
      {
        ...pagesConfig[25],
        actions: [
          optionsPages.actions.read[15],
          optionsPages.actions.create[3],
          optionsPages.actions.update[14],
          optionsPages.actions.update[15]
        ]
      }
    ]
  }
};

/**
 * Comprueba acciones permitidas al usuario.
 * @param {string[]} permissionNames Códigos de acción (p. ej. read-settings).
 * @param {{ path?: string }|undefined} options Si `path` está definido (p. ej. location.pathname), con BLI solo
 *   cuentan asignaciones del módulo que corresponde a esa ruta. Sin `path`, se mantiene el comportamiento previo
 *   (unión de todas las acciones asignadas en cualquier módulo).
 */
export const verifyAccessViewPermissions = (permissionNames, options) => {
  const pathOpt =
    options &&
    typeof options === "object" &&
    options.path != null &&
    String(options.path).trim() !== ""
      ? String(options.path).trim()
      : null;

  if (pathOpt) {
    const parsed = parseBliPermissionsFromSession();
    if (parsed?.modules?.length && Array.isArray(parsed.assignments)) {
      const modules = parsed.modules;
      const assignments = parsed.assignments;
      const moduleId = resolveModuleIdForPath(modules, pathOpt);

      const pathKey = normalizePathForBli(String(pathOpt).split("?")[0]).toLowerCase();
      const modulePathOf = (m) =>
        normalizePathForBli(String(m?.path ?? m?.Path ?? m?.Value ?? "").split("?")[0]).toLowerCase();
      const moduleIdOf = (m) => m?.moduleId ?? m?.ModuleId ?? m?.IdModulo ?? m?.IdModule;

      // Some catalogs can have multiple modules sharing the same path (e.g. parent + list).
      // In that case, validate permissions against any matching module id that has assignments.
      const candidateIds = [];
      if (moduleId != null) candidateIds.push(moduleId);
      for (const m of modules) {
        if (modulePathOf(m) === pathKey) {
          const mid = moduleIdOf(m);
          if (mid != null) candidateIds.push(mid);
        }
      }

      const uniqueCandidateIds = [...new Set(candidateIds.map((x) => String(x)))];
      if (!uniqueCandidateIds.length) return false;

      for (const midStr of uniqueCandidateIds) {
        const allowed = getActionCodesForModuleFromAssignments(assignments, midStr);
        if (!allowed?.length) continue;
        const set = new Set(allowed);
        if (permissionNames.every((name) => set.has(name))) return true;
      }

      return false;
    }

    let userRole;
    try {
      userRole = JSON.parse(sessionStorage.getItem("user"))?.roleId;
    } catch {
      return false;
    }

    const roleConfig = configRolesUsers[userRole];
    if (!roleConfig?.options) return false;
    const actionsForPath = actionsForPathFromStaticRole(roleConfig, pathOpt);
    if (!actionsForPath.length) return false;
    const set = new Set(actionsForPath);
    return permissionNames.every((name) => set.has(name));
  }

  const parsed = parseBliPermissionsFromSession();
  if (parsed && Array.isArray(parsed.assignments)) {
    const allowed = new Set(
      parsed.assignments.map((a) => a.actionCode ?? a.ActionCode).filter(Boolean)
    );
    return permissionNames.every((name) => allowed.has(name));
  }

  let userRole;
  try {
    userRole = JSON.parse(sessionStorage.getItem("user"))?.roleId;
  } catch {
    return false;
  }

  const roleConfig = configRolesUsers[userRole];
  if (!roleConfig?.options) return false;

  for (const permissionName of permissionNames) {
    let hasPermission = false;

    for (const option of roleConfig.options) {
      if (option.subNav) {
        for (const subPage of option.subNav) {
          if (subPage.actions && subPage.actions.includes(permissionName)) {
            hasPermission = true;
            break;
          }
        }
      } else if (option.actions && option.actions.includes(permissionName)) {
        hasPermission = true;
        break;
      }
    }

    if (!hasPermission) {
      return false;
    }
  }

  return true;
};

/**
 * Una lectura de BLI + rol por uso; reutilizar la función devuelta para todas las rutas del mismo render.
 * Si en session hay catálogo `modules` (no vacío): solo permite rutas que resuelven a uno de esos módulos.
 * No se usa `findActionsByPath` como fallback (evita que el rol estático en `configRolesUsers` abra rutas
 * no asignadas en BLI, p. ej. /dashboard/settings sin módulo SETTINGS en el payload).
 * Sin catálogo BLI: criterio del menú estático (`findActionsByPath`).
 *
 * En cada llamada se vuelve a leer sessionStorage.
 */
export function createPathAccessChecker() {
  return function canAccessPath(path) {
    const parsed = parseBliPermissionsFromSession();
    const modules = parsed?.modules;
    if (Array.isArray(modules) && modules.length > 0) {
      const moduleId = resolveModuleIdForPath(modules, path);
      return moduleId != null;
    }

    let userRole;
    try {
      userRole = JSON.parse(sessionStorage.getItem("user"))?.roleId;
    } catch {
      userRole = undefined;
    }
    const roleConfig = userRole != null ? configRolesUsers[userRole] : null;

    if (!roleConfig?.options) return false;
    return findActionsByPath(roleConfig, path).length > 0;
  };
}

/**
 * Actions allowed on a route: BLI assignments when cached, otherwise static role config.
 */
export const findActionsByPathWithFallback = (roleConfig, path) => {
  const parsed = parseBliPermissionsFromSession();
  if (parsed?.modules?.length && parsed?.assignments) {
    const moduleId = resolveModuleIdForPath(parsed.modules, path);
    if (moduleId != null) {
      return getActionCodesForModuleFromAssignments(parsed.assignments, moduleId);
    }
    return [];
  }
  if (!roleConfig?.options) return [];
  return findActionsByPath(roleConfig, path);
};